import DisputesList from './DisputesList';

export default DisputesList;
